import React from "react";
import {Tab, Tabs, Box} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import {inject, observer} from "mobx-react";
import {Location} from "@src/Interfaces/Entity/Location";
import {computed, observable} from "mobx";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import LocationsTable from "./LocationTable/LocationsTable";
import {Values} from "@src/Tools/Values";
import ResultsAreEmptyLabel from "@src/Components/Ui/ResultsAreEmpty";
import {STGrid} from "./styles";
import {IAuthStore} from "@src/Stores/Auth/types";
import {IValuesStore} from "@src/Stores/Values/types";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import {LocationDialog} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/LocationDialog";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import {ItemListPageTabWrapper, ItemListPageContentWrapper} from "@src/Shared/Layout/styles";

interface IProps {
    management?: IManagementStore;
    auth?: IAuthStore;
    values?: IValuesStore;
}

@inject("auth", "values", "management")
@observer
class LocationsContent extends React.Component<IProps> {
    @observable searchText: string = "";
    @observable deletedLocationsSearchText: string = "";
    @observable showDeletedLocations = false
    @observable tabIndex: number = 0;
    @observable showLocationDialog: boolean = false;
    @observable editLocation: Location = null;

    @computed get filteredLocations() {
        return filterByTableColumns<Location>(
            this.props.management.locations,
            this.searchText
        );
    }

    @computed get filteredDeletedLocations() {
        return filterByTableColumns<Location>(
            this.props.management.deletedLocations,
            this.deletedLocationsSearchText
        );
    }

    handleAddLocationDialog() {
        this.showLocationDialog = true;
    }

    onEditButtonClick(location: Location) {
        this.editLocation = location;
        this.showLocationDialog = true;
    }

    async onLocationDialogConfirm() {
        this.showLocationDialog = false;
        this.editLocation = null;
        await this.props.management.getLocations();
    }

    onLocationDialogCancel() {
        this.editLocation = null;
        this.showLocationDialog = false;
    }

    handleFilterChange = (text: string) => {
        this.searchText = text;
    };

    handleDeletedLocationsFilterChange = (text: string) => {
        this.deletedLocationsSearchText = text;
    };

    handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.tabIndex = newValue;
    };

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <ItemListPageTabWrapper>
                        <Tabs
                            value={this.tabIndex}
                            onChange={this.handleTabIndexChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("locations")}/>
                            {this.props.auth.user.roles.find(x => x == this.props.values.roles.Administrator) != null
                                && <Tab label={Values.getLocalizationValue("deletedLocations")}/>
                            }
                        </Tabs>
                    </ItemListPageTabWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.handleAddLocationDialog()}
                            text={Values.getLocalizationValue("addLocation")}
                        />
                    }
                </FullWidthFlexBox>

                <ItemListPageContentWrapper>
                    {this.tabIndex === 0
                        ? <Box>
                            <FullWidthSearch
                                value={this.searchText}
                                onChange={(text: string) => this.handleFilterChange(text)}
                            />

                            <STGrid item xs>
                                {this.filteredLocations.length > 0 ? (
                                    <LocationsTable
                                        locations={this.filteredLocations}
                                        onEditButtonClick={this.onEditButtonClick.bind(this)}
                                    />
                                ) : (
                                    <ResultsAreEmptyLabel/>
                                )}
                            </STGrid>
                        </Box>

                        : <Box>
                            <FullWidthSearch
                                value={this.deletedLocationsSearchText}
                                onChange={(text: string) => this.handleDeletedLocationsFilterChange(text)}
                            />

                            <STGrid item xs>
                                {this.filteredDeletedLocations.length > 0 ? (
                                    <LocationsTable
                                        locations={this.filteredDeletedLocations}
                                        onEditButtonClick={this.onEditButtonClick.bind(this)}
                                    />
                                ) : (
                                    <ResultsAreEmptyLabel/>
                                )}
                            </STGrid>
                        </Box>
                    }
                </ItemListPageContentWrapper>

                {this.showLocationDialog
                    && <LocationDialog
                        initialValues={this.editLocation}
                        onConfirm={() => this.onLocationDialogConfirm()}
                        onClose={() => this.onLocationDialogCancel()}
                        isOpened={this.showLocationDialog}
                    />
                }
            </>
        );
    }
}

export default LocationsContent;
